import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import { vRequired } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

export default class ContactTagAppliedForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          This flow will be triggered when the specified tag is added to a contact. Note, tags are
          case sensitive.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <Field name="tag" component={Input} label="Tag" validate={[vRequired]} />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactTagApplied/ContactTagAppliedForm.jsx